module.exports = __webpack_public_path__ + "fonts/05caf824-53b4-4d9b-ac35-8a6015f654c6.9a530c82.eot";